import React from 'react';
import {
  Box,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
} from 'components/mui';
import { AddIcon, RemoveIcon } from 'components/icons';
import useActivityLogManagement from './useActivityLogManagement';
import LoadingBackdrop from 'components/LoadingBackdrop';
import {
  ActivityLogList,
  ActivityLogForm,
  ActivityLogSearch,
  CustomerFilter,
} from 'containers/pages/activityLogManagement/components';

function ActivityLogManagement() {
  const { state, handler } = useActivityLogManagement();

  return (
    <Box
      component="main"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        p: { xs: 2, sm: 3 },
      }}
    >
      {/* Customer Filter */}
      <Box sx={{ width: { xs: '100%', md: '35%' } }}>
        <CustomerFilter
          value={state.customerFilter}
          options={state.customerFilterOptions}
          onChange={handler.onCustomerFilterChange}
          onInputChange={handler.onCustomerFilterSearch}
          onOpen={handler.onCustomerFilterOpen}
        />
      </Box>

      {/* Header row */}
      <Grid
        container
        alignItems="stretch"
        spacing={2}
        wrap="nowrap"
      >
        <Grid item>
          <Button
            variant="contained"
            startIcon={state.isOpenForm ? <RemoveIcon /> : <AddIcon />}
            onClick={handler.onToggleForm}
            sx={{
              display: 'flex',
              alignItems: 'center',
              px: 2,
              height: '100%',
              whiteSpace: 'nowrap',
            }}
          >
            <Box sx={{ display: { xs: 'none', sm: 'inline' } }}>NEW ACTIVITY LOG</Box>
            <Box sx={{ display: { xs: 'inline', sm: 'none' } }}>NEW</Box>
          </Button>
        </Grid>

        <Grid item xs>
          <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            <ActivityLogSearch
              searchInput={state.searchInput}
              onSearchInput={handler.onSearchInput}
              onReset={handler.onResetSearch}
            />
          </Box>
        </Grid>
      </Grid>

      {/* New Activity Log Dialog */}
      <Dialog open={state.isOpenForm} onClose={handler.onToggleForm} maxWidth="md" fullWidth>
        <DialogTitle>New Activity Log</DialogTitle>
        <DialogContent>
          <Box sx={{ pt: 1 }}>
            <ActivityLogForm mode="add" onSave={handler.onSaveActivityLog} />
          </Box>
        </DialogContent>
      </Dialog>

      {/* Main activity log list */}
      <ActivityLogList
        activityLogs={state.searchedLogs}
        onSave={handler.onSaveActivityLog}
      />

      <LoadingBackdrop open={state.isLoading} />
    </Box>
  );
}

export default ActivityLogManagement;
